// Chi vede l'Area commerciale: stesse regole di GET /area-commerciale
// (backend/routes/area_commerciale.py). Condivise da pagina, Sidebar, MobileNav
// e dal reindirizzamento di /dashboard in App.js.

// `is_admin` arriva dal backend (compute_is_admin): admin, responsabile
// operativo, direttori tecnico e commerciale.
export function eDirezione(user) {
  return !!user?.is_admin;
}

export function eCommerciale(user) {
  return user?.role === "commerciale" || (user?.secondary_roles || []).includes("commerciale");
}

export function puoVedereAreaCommerciale(user) {
  return eDirezione(user) || eCommerciale(user);
}
